export default "__VITE_PUBLIC_ASSET__d7acc7bb__"